import React, { useEffect, createElement } from 'react';
import { ReconquistaLandingPage } from './pages/ReconquistaLandingPage';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
  queue?: unknown[][];
};
declare global {
  interface Window {
    __metaPixelInitialized?: boolean;
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
const META_PIXEL_ID = '1491615965191161';
export function App() {
  useEffect(() => {
    if (window.__metaPixelInitialized) return;
    const fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue?.push(args);
      }
    } as MetaPixelFunction;
    fbq.push = (...args: unknown[]) => {
      fbq.queue?.push(args);
    };
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
    window.__metaPixelInitialized = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <ReconquistaLandingPage data-id="element-0" />;
}